// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__2vNVJ","marketplaceStroke":"IconEmailAttention_marketplaceStroke__12q13","attentionStroke":"IconEmailAttention_attentionStroke__2l6OO"};